import React from "react";

export const TelegramIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0H4ZM20.2979 5.31059L17.4781 18.8738C17.4117 19.194 17.0362 19.3391 16.7713 19.1466L12.922 16.352C12.6884 16.1823 12.3697 16.1914 12.146 16.3738L10.0119 18.1134C9.7642 18.316 9.39096 18.2031 9.29612 17.898L8.39686 15.006C8.02937 13.8241 7.13545 12.8789 5.97588 12.4462L3.98569 11.7034C3.59678 11.5577 3.59346 11.0087 3.98126 10.8593L19.6937 4.79784C20.0268 4.66903 20.3705 4.96083 20.2979 5.31059Z"
        fill="#008769"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5398 7.76329L9.05739 12.3717C8.7706 12.5486 8.63562 12.895 8.72814 13.2192L9.53713 16.0618C9.59467 16.2632 9.88689 16.2426 9.9149 16.0345L10.1252 14.4757C10.1649 14.1822 10.3048 13.9117 10.5219 13.7097L16.697 7.96964C16.8126 7.86256 16.6742 7.68074 16.5398 7.76329Z"
        fill="#008769"
      />
    </svg>
  );
};
